import { useTranslation } from 'react-i18next';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

import type { DataLayerType } from '../model/types';
import { DATA_LAYER_CONFIG, getDataLayerConfig } from '../lib/data-layer.utils';

interface DataLayerSelectorProps {
  activeLayer: DataLayerType;
  onLayerChange: (layer: DataLayerType) => void;
}

export function DataLayerSelector({ activeLayer, onLayerChange }: DataLayerSelectorProps) {
  const { t } = useTranslation();

  return (
    <div className="absolute top-4 right-2 sm:right-4 left-2 sm:left-auto max-w-[calc(100%-1rem)] sm:max-w-md bg-white rounded-lg shadow-lg p-1 sm:p-2 z-[1000]">
      <ToggleGroup
        type="single"
        className="flex-wrap justify-center sm:justify-end gap-1"
        value={activeLayer}
        onValueChange={(value) => value && onLayerChange(value as DataLayerType)}>
        {Object.entries(DATA_LAYER_CONFIG).map(([key, baseConfig]) => {
          const config = getDataLayerConfig(key as DataLayerType, t);
          const Icon = baseConfig.icon;
          return (
            <ToggleGroupItem
              key={key}
              value={key}
              aria-label={config.label}
              className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground">
              <Icon className={`h-4 w-4 mr-2 ${activeLayer === key ? '' : baseConfig.color}`} />
              <span className="text-sm">{config.label}</span>
            </ToggleGroupItem>
          );
        })}
      </ToggleGroup>
    </div>
  );
}
